// @ts-check
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';

import { resetFilters } from 'actions/organisation';
import { Button, SearchButton } from 'components/common';
import { useDefaultCategories } from 'hooks/useDefaultSearchCategories';

import OrgFilterSections from './OrgFilterSections';

// The filter panel for the org People and Activity tabs. Both tabs bind to the
// same `filters[orgId]` slice and render the same section stack, so the panels
// only differ by the analytics `searchLocation` and the search they trigger.

const Actions = styled.div`
  padding-top: 10px;
  display: flex;
  justify-content: flex-end;
  position: sticky;
  bottom: 0;
  padding-bottom: 10px;
  background: white;
`;

const OrgFilterPanel = ({
  organisationId,
  onFilterUpdate,
  loading,
  handleCancel,
  searchLocation,
}) => {
  const dispatch = useDispatch();
  const defaultCategories = useDefaultCategories();

  // Reset must re-run this tab's search as well as clear the filters. The
  // shared-slice stale flags only auto-run a tab when you activate it, so
  // clearing alone leaves the tab you are on showing its old filtered results.
  const handleReset = () => {
    dispatch(resetFilters(organisationId, defaultCategories));
    onFilterUpdate();
  };

  return (
    <>
      <OrgFilterSections organisationId={organisationId} loading={loading} />
      <Actions>
        <Button
          data-testid='filter-reset'
          onClick={handleReset}
          disabled={loading}
        >
          Reset
        </Button>
        <SearchButton
          type='primary'
          style={{ marginLeft: '10px' }}
          data-testid='filter-update'
          loading={loading}
          disabled={loading}
          onSearch={() => onFilterUpdate()}
          onCancel={handleCancel}
          location={searchLocation}
        />
      </Actions>
    </>
  );
};

OrgFilterPanel.propTypes = {
  organisationId: PropTypes.number.isRequired,
  onFilterUpdate: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  handleCancel: PropTypes.func,
  searchLocation: PropTypes.string.isRequired,
};

export default OrgFilterPanel;
